import ColorsDefaultC from "../../containers/color-defaults/ColorsDefaultC";

type Props = {};

const ColorsDefault = (props: Props) => {
  return <ColorsDefaultC />;
};

export default ColorsDefault;
